import React from 'react'
import { useTranslation } from 'react-i18next'

import { useServices } from '@percent/admin-dashboard/containers/service/ServiceContext'
import { PartnerScopes } from '@percent/admin-dashboard/constants/scopes'
import { useMutation } from '@percent/admin-dashboard/common/hooks'
import { Dialog, DialogDeleteBody } from '@percent/admin-dashboard/common/components'

type PartnerModuleActiveDialogProps = {
  openActiveModal: boolean
  onClose: () => void
  refresh: () => void
  partnerId: string
  scope: PartnerScopes
  moduleTitle: string
}

export function PartnerModuleActiveDialog({
  openActiveModal = false,
  onClose,
  refresh,
  partnerId,
  scope,
  moduleTitle
}: PartnerModuleActiveDialogProps) {
  const { adminService } = useServices()
  const [{ errorMessage }, { apiFunc }] = useMutation(adminService.commands.addPartnerScope, () => {
    onClose()
    refresh()
  })
  const { t } = useTranslation()

  const handleSubmit = () => apiFunc({ scope, id: partnerId })

  return (
    <Dialog openModal={openActiveModal} onClose={onClose} headerTitle={`${t('typography.activate')} ${moduleTitle}`}>
      <DialogDeleteBody
        bodyText={
          <p>
            <span style={{ fontFamily: 'MarkProMedium' }}>{moduleTitle} </span>
            {t('typography.willBeActivated')}
          </p>
        }
        errorMessage={errorMessage}
        handleSubmit={handleSubmit}
        buttonTitle={t('button.active')}
        testId="active-module-button"
      />
    </Dialog>
  )
}
